import * as types from './actionTypes';


export function showContactPersonModal() {
    return {type: types.SHOW_CONTACT_PERSON_MODAL, status: true};
}

export function hideContactPersonModal() {
    return {type: types.HIDE_CONTACT_PERSON_MODAL, status: false};
}




// WEBPACK FOOTER //
// ./web/src/actions/contactPersonModalActions.js